import React, { ReactElement, useCallback, useEffect, useState } from "react";
import { Button } from "antd";
import "./index.scss";
import {
  Outlet,
  useNavigate,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import { useTranslation } from "react-i18next";

import {
  AddAddress,
  AddTitle,
  InvoicingStatistic,
} from "../../../api/personal";
import { IS_MOBILE } from "@/utils/tool";

import TitleModal from "../../../components/Modal/Title";
import Address4Personal from "../../../components/Modal/Address/Address4Personal";
const btnInfo = {
  title: [
    {
      text: "添加发票抬头",
    },
  ],
  address: [
    {
      text: "添加收件地址",
    },
  ],
};

// TODO:这里可以抽一个HOC,处理共有逻辑,但是由于其他两个组件,暂时没定,所以直接将逻辑下放到各自组件中
const InvoiceManagement: React.FC = () => {
  const [urlSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const pathnameParts = location.pathname.split("/");
  const lastPart = pathnameParts[pathnameParts.length - 1];
  const [titleModalVisible, setTitleModalVisible] = useState(false);
  const [addressModalVisible, setAddressModalVisible] = useState(false);
  const { t } = useTranslation();

  const [statistic, setStatistic] = useState<{
    address_num: number;
    bill_num: number;
    title_num: number;
  }>({
    address_num: 0,
    bill_num: 0,
    title_num: 0,
  });
  useEffect(() => {
    const fetchInvoicingStatistic = async () => {
      const res = await InvoicingStatistic<{
        address_num: number;
        bill_num: number;
        title_num: number;
      }>();
      if (res.code === 0) {
        const { address_num, bill_num, title_num } = res.data;
        setStatistic({
          address_num,
          bill_num,
          title_num,
        });
      }
    };
    fetchInvoicingStatistic();
  }, [urlSearchParams.get("randomKey")]);

  const switchPath = useCallback((path: string) => {
    navigate(path);
  }, []);

  const submitAction4Btn = useCallback(
    async (params, page: "title" | "address") => {
      if (page === "title") {
        const res = await AddTitle(params);
        if (res.code === 0) {
          navigate(
            `${location.pathname}?randomKey=${Math.random()
              .toString(32)
              .slice(2)}`
          );
        }
      }
      if (page === "address") {
        const res = await AddAddress(params);
        if (res.code === 0) {
          navigate(
            `${location.pathname}?randomKey=${Math.random()
              .toString(32)
              .slice(2)}`
          );
        }
      }
    },
    [location.pathname]
  );

  const handleClick = () => {
    if (lastPart === "title") {
      setTitleModalVisible(true);
    }
    if (lastPart === "address") {
      setAddressModalVisible(true);
    }
  };

  return (
    <section
      className={`invoice-management-wrapper ${
        IS_MOBILE ? "mobile-invoice-management-wrapper" : ""
      }`}
    >
      <div className="header-wrapper">
        <div className="tabs">
          {/* TODO:这里可以事件委托 */}
          <div
            onClick={() => switchPath("all")}
            className={`${location.pathname.includes("all") ? "active" : ""}`}
          >
            {t("全部发票")} <span>{statistic.bill_num}</span>
          </div>
          <div
            onClick={() => switchPath("title")}
            className={`${location.pathname.includes("title") ? "active" : ""}`}
          >
            {t("抬头管理")} <span>{statistic.title_num}</span>
          </div>
          {/* <div
            onClick={() => switchPath("address")}
            className={`${
              location.pathname.includes("address") ? "active" : ""
            }`}
          >
            {t("地址管理")} <span>{statistic.address_num}</span>
          </div> */}
        </div>
        <div className="btn-wrapper">
          {btnInfo[lastPart] &&
            btnInfo[lastPart].map((item) => (
              <Button
                onClick={handleClick}
                key={item.text}
                className="btn-primary"
              >
                {t(item.text)}
              </Button>
            ))}
        </div>
      </div>
      <Outlet />
      {titleModalVisible && (
        <TitleModal
          hiddenModal={() => setTitleModalVisible(false)}
          title={t("添加发票抬头")}
          submitAction={(params) =>
            submitAction4Btn(params, lastPart as "title")
          }
        />
      )}
      {addressModalVisible && (
        <Address4Personal
          hiddenModal={() => setAddressModalVisible(false)}
          title={t("添加收件地址")}
          submitAction={(params) =>
            submitAction4Btn(params, lastPart as "address")
          }
        />
      )}
    </section>
  );
};

export default InvoiceManagement;
